﻿﻿// Firebase Configuration for What To Eat?
// Single configuration point loaded in HEAD before modular bootstrap.
// v2.0 - Phase 1 Security: Added App Check, cleaned up legacy wrappers

const defaultFirebaseConfig = {
  apiKey: "AIzaSyDlLZGOyNv-zhlMINIQguKp8g2y6MgzrjU",
  authDomain: "what-toeat.com",
  projectId: "what-to-eat-e5ce9",
  storageBucket: "what-to-eat-e5ce9.firebasestorage.app",
  messagingSenderId: "787994077256",
  appId: "1:787994077256:web:2849e5b2552a323e6e507d",
  measurementId: "G-6P3T9PRVPB"
};
const firebaseConfigOverride = typeof window !== "undefined" ? window.__FIREBASE_CONFIG_OVERRIDE__ : null;
const firebaseConfig = firebaseConfigOverride && typeof firebaseConfigOverride === "object"
  ? { ...defaultFirebaseConfig, ...firebaseConfigOverride }
  : defaultFirebaseConfig;

const FIREBASE_CONFIG_VERSION = "2026-09-01-1";
console.log("[Firebase Config] LOADED FROM firebase-config.js version:", FIREBASE_CONFIG_VERSION);

// Expose config globally for firebase-sdk-bootstrap.js
window.firebaseConfig = firebaseConfig;

/**
 * Firebase App Check configuration.
 * The public site key must come from the real Firebase/App Check project.
 * This file intentionally fails closed: App Check only initializes when a valid key is present.
 */
window.__APP_CHECK_SITE_KEY__ = window.__APP_CHECK_SITE_KEY__ || "6LenU6ItAAAAAEKCub2Xo5-XTk3sEHR6LGh4aLvu";
window.__RECAPTCHA_SITE_KEY__ = window.__RECAPTCHA_SITE_KEY__ || window.__APP_CHECK_SITE_KEY__ || "";
window.__RECAPTCHA_V3_SITE_KEY__ = window.__RECAPTCHA_V3_SITE_KEY__ || window.__RECAPTCHA_SITE_KEY__ || "";

const firebaseSecurityHost = typeof window !== 'undefined' && typeof window.location !== 'undefined'
  ? String(window.location.hostname || '').toLowerCase()
  : '';
const isLocalhostHost = firebaseSecurityHost === 'localhost' || firebaseSecurityHost === '127.0.0.1' || firebaseSecurityHost === '[::1]';
const configuredAppCheckKey = String(window.__APP_CHECK_SITE_KEY__ || '').trim();
const configuredRecaptchaKey = String(window.__RECAPTCHA_SITE_KEY__ || window.__RECAPTCHA_V3_SITE_KEY__ || '').trim();
const productionSecurityBlocked = !isLocalhostHost && (!configuredAppCheckKey || !configuredRecaptchaKey);

if (typeof window !== 'undefined' && typeof window.location !== 'undefined') {
  // Use a debug token only when local development has no real App Check key.
  // A forced debug token takes precedence over the configured provider and
  // causes Firebase to reject requests until that exact token is registered.
  if (isLocalhostHost && !configuredAppCheckKey) {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
}

window.firebaseAppCheckConfig = {
  enabled: !isLocalhostHost && Boolean(configuredAppCheckKey),
  provider: 'recaptchaEnterprise',
  siteKey: configuredAppCheckKey,
  note: 'Production deployments require a valid App Check site key for every non-localhost domain. Localhost stays allowed only for development debug mode.'
};

/**
 * reCAPTCHA configuration for registration form bot protection.
 * These keys must come from the real Google reCAPTCHA project for the production app.
 */
window.recaptchaConfig = {
  siteKey: configuredRecaptchaKey,
  v3SiteKey: String(window.__RECAPTCHA_V3_SITE_KEY__ || configuredRecaptchaKey || '').trim()
};

window.productionSecurityConfig = {
  host: firebaseSecurityHost,
  isLocalhost: isLocalhostHost,
  requiresProductionSecurity: !isLocalhostHost,
  hasAppCheckKey: Boolean(configuredAppCheckKey),
  hasRecaptchaKey: Boolean(configuredRecaptchaKey),
  blocked: productionSecurityBlocked,
  note: 'Public domains are blocked until Firebase App Check and reCAPTCHA are configured in the production environment.'
};

window.phase1AlphaConfig = {
  enabled: true,
  name: 'controlled-beta',
  note: 'Phase 1 controlled-beta mode requires valid App Check and reCAPTCHA keys for non-localhost domains before external sign-ups are allowed.',
  allowedLocalHosts: ['localhost', '127.0.0.1', '[::1]'],
  requireAppCheckForPublicDomain: true,
  requireRecaptchaForPublicDomain: true,
  productionSecurityBlocked
};

/**
 * Legacy compatibility wrappers.
 * The actual Firebase initialization now happens in firebase-sdk-bootstrap.js (modular).
 * These wrappers provide the same names expected by the rest of the app.
 */

window.initFirebase = async function initFirebase() {
  if (typeof window.ensureFirebaseReady === "function") {
    return window.ensureFirebaseReady();
  }
  return null;
};

window.ensureFirebaseReady = async function ensureFirebaseReady() {
  if (typeof window.firebaseReady === "boolean" && window.firebaseReady) {
    return { auth: window.firebaseAuthInstance, db: window.firebaseDbInstance };
  }

  // Wait briefly for modular bootstrap to attach ensureFirebaseReady
  for (let i = 0; i < 50; i++) {
    if (typeof window.ensureFirebaseReady === "function" && window.firebaseReady) {
      return { auth: window.firebaseAuthInstance, db: window.firebaseDbInstance };
    }
    await new Promise((r) => setTimeout(r, 100));
  }

  console.error("[Firebase Config] ensureFirebaseReady timed out.");
  return null;
};

// Getter helpers
window.getFirebaseAuthInstance = () => window.firebaseAuthInstance || null;
window.getFirebaseDbInstance = () => window.firebaseDbInstance || null;
window.getFirebaseAuth = () => window.firebaseAuthInstance || null;
window.getFirebaseDb = () => window.firebaseDbInstance || null;

/**
 * Legacy sign-in/out wrappers:
 * These delegate to the real implementations in firebase-sdk-bootstrap.js and firebase-integration.js.
 * They wait for Firebase to be ready before delegating.
 */

// Helper: wait for Firebase to be ready
async function waitForFirebaseReady() {
  if (window.firebaseReady) return true;
  if (typeof window.ensureFirebaseReady === 'function') {
    const result = await window.ensureFirebaseReady();
    return result !== null;
  }
  // Poll up to 10 seconds
  for (let i = 0; i < 100; i++) {
    if (window.firebaseReady) return true;
    await new Promise(r => setTimeout(r, 100));
  }
  return false;
}

// Helper: get the RAW modular Auth instance.
// The v8-compatible wrapper (window.firebaseAuthInstance) exposes the raw
// modular instance via its _raw property; window.firebaseAuthRaw is also set.
function getRawFirebaseAuth() {
  if (window.firebaseAuthRaw) return window.firebaseAuthRaw;
  if (window.firebaseAuthInstance && window.firebaseAuthInstance._raw) {
    return window.firebaseAuthInstance._raw;
  }
  return window.firebaseAuthInstance || null;
}

// Sign in with email/password - delegates to firebase-sdk-bootstrap.js
window.signInWithEmail = async function (email, password) {
  await waitForFirebaseReady();
  const rawAuth = getRawFirebaseAuth();
  if (typeof window.signInWithEmailAndPassword === 'function' && rawAuth) {
    return window.signInWithEmailAndPassword(rawAuth, email, password);
  }
  // Fallback to firebase-integration.js
  if (typeof window.firebaseSignIn === 'function') {
    return window.firebaseSignIn(email, password);
  }
  throw new Error('[Firebase Config] Firebase Auth not available');
};

// Sign up with email/password - delegates to firebase-sdk-bootstrap.js
window.signUpWithEmail = async function (email, password) {
  await waitForFirebaseReady();
  const rawAuth = getRawFirebaseAuth();
  if (typeof window.createUserWithEmailAndPassword === 'function' && rawAuth) {
    return window.createUserWithEmailAndPassword(rawAuth, email, password);
  }
  // Fallback to firebase-integration.js
  if (typeof window.firebaseSignUp === 'function') {
    return window.firebaseSignUp(email, password, 'client', {});
  }
  throw new Error('[Firebase Config] Firebase Auth not available');
};

// Sign in with Google - delegates to firebase-integration.js
window.signInWithGoogle = async function () {
  await waitForFirebaseReady();
  const rawAuth = getRawFirebaseAuth();
  if (rawAuth && window.firebaseGoogleProvider) {
    const { signInWithPopup } = await import('https://www.gstatic.com/firebasejs/12.18.0/firebase-auth.js');
    return signInWithPopup(rawAuth, window.firebaseGoogleProvider);
  }
  throw new Error('[Firebase Config] Google Auth not available');
};

// Sign out from Firebase
window.signOutFromFirebase = async function () {
  await waitForFirebaseReady();
  const rawAuth = getRawFirebaseAuth();
  if (typeof window.modularSignOut === 'function' && rawAuth) {
    return window.modularSignOut(rawAuth);
  }
  if (typeof window.firebaseSignOut === 'function') {
    return window.firebaseSignOut();
  }
  throw new Error('[Firebase Config] Firebase Auth not available');
};

// Get current Firebase user
window.getCurrentFirebaseUser = function () {
  const rawAuth = getRawFirebaseAuth();
  if (rawAuth && rawAuth.currentUser) {
    return rawAuth.currentUser;
  }
  if (typeof window.getCurrentUser === 'function') {
    return window.getCurrentUser();
  }
  return null;
};

// Check if Firebase is authenticated
window.isFirebaseAuthenticated = function () {
  const user = window.getCurrentFirebaseUser();
  return user !== null;
};

// ============ STRIPE PAYMENT CONFIGURATION ============
// Used for provider subscription payments via Stripe Checkout.
// The publishable key is safe to expose client-side.
// The secret key & webhook secret are stored server-side via Firebase Functions config.
// Replace the placeholder below with your actual Stripe publishable key when available.
const runtimeProcess = typeof process !== 'undefined' ? process : null;
const stripePublicKey = String(window.__STRIPE_PUBLISHABLE_KEY__ || (runtimeProcess && runtimeProcess.env ? runtimeProcess.env.STRIPE_PUBLISHABLE_KEY : '') || "").trim();
const stripePublishableKey = String(stripePublicKey || "").trim();
const stripePlaceholderValues = new Set(["", "replace-me", "demo", "example", "pk_test_placeholder", "pk_live_placeholder", "test"]);
const hasRealStripeKey = stripePublishableKey.length > 0 && !stripePlaceholderValues.has(stripePublishableKey.toLowerCase());
const stripeMode = String((window.__STRIPE_MODE__ || (runtimeProcess && runtimeProcess.env && runtimeProcess.env.STRIPE_MODE) || 'sandbox')).trim().toLowerCase();
const isStripeSandbox = stripeMode === 'sandbox' || stripeMode === 'test' || !stripeMode;

window.stripeConfig = {
  publishableKey: stripePublishableKey,
  mode: isStripeSandbox ? 'sandbox' : 'live',
  enabled: hasRealStripeKey && isStripeSandbox,
  sandboxMode: isStripeSandbox,
  isReadyForCheckout: hasRealStripeKey && isStripeSandbox,
  isProductionSafe: !isStripeSandbox && hasRealStripeKey,
  note: hasRealStripeKey
    ? 'Stripe is configured for sandbox/test mode only until production approval is complete.'
    : 'Stripe is not configured. The app blocks real subscription checkout until a valid publishable key is set and the mode is verified.',
  plans: {
    free: { name: "Free Plan", price: 0, interval: "one-time" },
    basic: { name: "Basic Plan", price: 100.50, interval: "month" },
    premium: { name: "Premium Plan", price: 200.00, interval: "month" }
  }
};

window.__STRIPE_CONFIG__ = window.stripeConfig;

// ============ FIREBASE STORAGE CONFIG HELPERS ============
// Provides safe access to the Firebase Storage instance initialized by
// firebase-sdk-bootstrap.js / firebase-storage-integration.js.

/**
 * Get the Firebase Storage instance (initialized by bootstrap module).
 * @returns {Object|null} The Storage instance or null if not initialized.
 */
window.getFirebaseStorageInstance = function () {
  return window.firebaseStorageInstance || null;
};

/**
 * Check whether Firebase Storage is initialized and ready.
 * @returns {boolean}
 */
window.isFirebaseStorageReady = function () {
  return window.firebaseStorageReady === true;
};

/**
 * Get the Firebase Storage bucket name.
 * @returns {string} e.g. "what-to-eat-e5ce9.firebasestorage.app"
 */
window.getFirebaseStorageBucket = function () {
  const cfg = window.firebaseConfig;
  return (cfg && cfg.storageBucket) ? cfg.storageBucket : "what-to-eat-e5ce9.firebasestorage.app";
};

/**
 * Wait until Firebase Storage is initialized.
 * @param {number} [timeoutMs=10000] Max wait time in milliseconds.
 * @returns {Promise<Object>} Resolves with the Storage instance.
 */
window.waitForFirebaseStorageReady = async function (timeoutMs) {
  const maxWait = timeoutMs || 10000;
  const start = Date.now();
  while (Date.now() - start < maxWait) {
    if (window.firebaseStorageInstance && window.firebaseStorageReady) {
      return window.firebaseStorageInstance;
    }
    // Trigger any module-level init if available
    if (typeof window.ensureFirebaseReady === "function" && window.firebaseReady === false) {
      try { await window.ensureFirebaseReady(); } catch (e) {}
    }
    await new Promise((r) => setTimeout(r, 100));
  }
  console.warn("[Firebase Config] waitForFirebaseStorageReady timed out after", maxWait, "ms");
  return null;
};
